import { z } from "zod";

export const COMPENSATORY_REQUEST_STATUSES = ["pending", "approved", "rejected"] as const;
export const compensatoryRequestStatusSchema = z.enum(COMPENSATORY_REQUEST_STATUSES);

export const compensatoryRequestSchema = z
  .object({
    id: z.string(),
    membershipId: z.string(),
    leaveTypeId: z.string().nullable(),
    workFromDate: z.string(),
    workEndDate: z.string(),
    halfDay: z.boolean(),
    reason: z.string(),
    status: compensatoryRequestStatusSchema,
    decidedByUserId: z.string().nullable(),
    decidedAt: z.string().nullable(),
    decisionNote: z.string().nullable(),
    version: z.number(),
    credit: z.string(),
    expiresOn: z.string().nullable(),
  })
  .strict();
export type CompensatoryRequest = z.infer<typeof compensatoryRequestSchema>;

export const compensatoryRequestPageSchema = z
  .object({
    rows: z.array(compensatoryRequestSchema),
    nextCursor: z.string().nullable(),
  })
  .strict();
export type CompensatoryRequestPage = z.infer<typeof compensatoryRequestPageSchema>;

export const compensatoryToDecideSchema = z
  .object({
    pendingCount: z.number(),
    items: z.array(
      compensatoryRequestSchema.extend({ displayName: z.string(), filedAt: z.string() }),
    ),
  })
  .strict();
export type CompensatoryToDecide = z.infer<typeof compensatoryToDecideSchema>;

export const decidedCompensatoryRequestSchema = compensatoryRequestSchema.extend({
  grantedDays: z.string().nullable(),
  allocationId: z.string().nullable(),
});

export const compensatoryCreateSchema = z
  .object({
    workedDate: z.string().min(1, "Pick the date you worked."),
    halfDay: z.boolean(),
    reason: z.string().trim().min(1, "Add a reason for the claim.").max(2_000),
  })
  .strict();
export type CompensatoryCreateInput = z.infer<typeof compensatoryCreateSchema>;
